import React from "react";
import { useTranslation } from "react-i18next";

import {
  DeliveryOptions,
  PhoneOrEmailInputField,
  TranslationContext,
} from "@is/constants";
import { FieldState } from "@is/types";
import { CheckoutInputFields, FieldsValidation } from "@is/types/checkout";

import CheckoutFormSection from "../CheckoutFormSection";
import CheckoutFormSectionTitle from "../CheckoutFormSectionTitle";
import css from "./CheckoutForm.module.css";

type Props = {
  onChange: (name: CheckoutInputFields, type: string, value: string) => void;
  onSaveCheckoutInfo: () => void;
  validation: FieldsValidation;
  recipientOptions?: FieldState[];
  deliveryOptions?: FieldState[];
  phoneOrEmailField?: PhoneOrEmailInputField;
  onPhoneOrEmailChange?: (name: PhoneOrEmailInputField) => void;
  activeDeliveryOption: DeliveryOptions;
  storeName: string;
  storeAddress: string;
};

const CheckoutForm = ({
  onChange,
  onSaveCheckoutInfo,
  validation,
  deliveryOptions,
  recipientOptions,
  phoneOrEmailField,
  onPhoneOrEmailChange,
  activeDeliveryOption,
  storeName,
  storeAddress,
}: Props) => {
  const { t } = useTranslation(TranslationContext.Checkout);

  return (
    <div className={css.container}>
      {!!recipientOptions?.length && (
        <CheckoutFormSection
          title={t("Your info")}
          options={recipientOptions}
          onChange={onChange}
          onSaveCheckoutInfo={onSaveCheckoutInfo}
          validation={validation}
          phoneOrEmailField={phoneOrEmailField}
          onPhoneOrEmailChange={onPhoneOrEmailChange}
        />
      )}
      {activeDeliveryOption === DeliveryOptions.HomeDelivery ? (
        !!deliveryOptions?.length && (
          <CheckoutFormSection
            title={t("Delivery address")}
            options={deliveryOptions}
            onChange={onChange}
            onSaveCheckoutInfo={onSaveCheckoutInfo}
            validation={validation}
            phoneOrEmailField={phoneOrEmailField}
            onPhoneOrEmailChange={onPhoneOrEmailChange}
          />
        )
      ) : (
        <div className={css.inStoreOptionContainer}>
          <CheckoutFormSectionTitle title={t("Delivery address")} />
          <div className={css.inStoreOption}>
            <span className={css.storeName}>{storeName}</span>
            <span className={css.storeAddress}>{storeAddress}</span>
          </div>
        </div>
      )}
    </div>
  );
};
export default CheckoutForm;
